import { apiInstance } from "./ApiInstance";

export const getAllCasesList = async (route, payload) => {
  let { data = {} } = await apiInstance.post(
    `api/case/case-list/${route}`,
    payload
  );
  return data;
};

export const getAllCasesSegmentInfo = async (route, payload, signal) => {
  let { data = {} } = await apiInstance.post(
    `/api/case/get-case-details/${route}`,
    payload,
    { signal }
  );
  return data;
};

export const submitFinalDeEmpanelSegment = async (type, payload) => {
  let { data = {} } = await apiInstance.put(
    `de-empanel/approve-de-empanel-${type}`,
    payload
  );
  return data;
};

export const caseDescriptionPut = async (route, payload, type) => {
  if (route === "Recommendation") {
    let { caseId, description: remarks, blackListType } = payload;
    return submitFinalDeEmpanelSegment(type, {
      caseId,
      remarks,
      blackListType,
    });
  }
  let { data = {} } = await apiInstance.put(
    `/api/case/description/${route}`,
    payload
  );
  return data;
};

export const putInvestigationDetails = async (payload) => {
  let { data = {} } = await apiInstance.put("api/bimasathi/summary", payload);
  return data;
};

export const getLocationList = async () => {
  let { data = {} } = await apiInstance.get(
    "api/allocation/serviced-location-list"
  );
  return data;
};

export const assignedBlocks = async (payload, signal) => {
  let { data = {} } = await apiInstance.post(
    // "/api/case/block-assignment-vendor-allocation",
    "/api/allocation/assign-vendor",
    payload,
    { signal }
  );
  return data;
};

export const getGradeCaseInfo = async (caseNo) => {
  let { data = {} } = await apiInstance.get(`api/case/grade-info/${caseNo}`);
  return data;
};

export const getInvestigationReportInfo = async (caseNo) => {
  let { data = {} } = await apiInstance.get(`api/case/get-investigation-report/${caseNo}`);
  return data;
};

export const storeInvestigationReportComment = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "api/case/add-ir-comment",
    payload
  );
  return data;
};

export const getGradeCasesByCaseNo = async (caseNo) => {
  let { data = {} } = await apiInstance.get(`api/case/grade-case/${caseNo}`);
  return data;
};

export const submitGradeCase = async (caseNo, payload) => {
  let { data = {} } = await apiInstance.put(
    `api/case/grade-case/${caseNo}`,
    payload
  );
  return data;
};

export const approveAction = async (caseNo) => {
  let { data = {} } = await apiInstance.put(`api/case/approve/${caseNo}`);
  return data;
};

export const rejectCase = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/case/reject/${caseId}`,
    payload
  );
  return data;
};

export const submitFinal = async (caseNo, payload) => {
  let { data = {} } = await apiInstance.put(
    `api/case/submit-final/${caseNo}`,
    payload
  );
  return data;
};

export const policeComplaintPostApi = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "de-empanel/police-complaint",
    payload
  );
  return data;
};

export const recommendation = async (caseNo, payload) => {
  let { data = {} } = await apiInstance.put(
    `api/case/recommendation/${caseNo}`,
    payload
  );
  return data;
};

export const vendorDetailInfoOFAllocated = async (payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/case/investigator-list`,
    payload
  );
  return data;
};

export const holdUnholdApi = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/case/hold-unhold-case/${caseId}`,
    payload
  );
  return data;
};

export const getPeerReviewApi = async (caseId) => {
  let { data = {} } = await apiInstance.get(`api/case/peer-reviews/${caseId}`);
  return data;
};

export const peerReviewApi = async (payload) => {
  let { data = {} } = await apiInstance.post(`/api/case/peer-review`, payload);
  return data;
};

export const getStateMaster = async () => {
  let { data = {} } = await apiInstance.get("/api/utils/state-master");
  return data;
};

export const getCitiesByState = async (state) => {
  const encodeURL = encodeURIComponent(state);
  let { data = {} } = await apiInstance.get(
    `/api/utils/city-by-state?state=${encodeURL}`
  );
  return data;
};

export const getIMsByStateyAndCity = async (location = {}) => {
  let { state = "", city = "", caseId = "" } = location;
  let { data = {} } = await apiInstance.get(
    `/api/utils/im-by-location?state=${encodeURIComponent(
      state
    )}&city=${encodeURIComponent(city)}&caseId=${encodeURIComponent(caseId)}`
  );
  return data;
};

export const getBSsByStateyAndCity = async (location = {}) => {
  let { state = "", city = "", case_id = "" } = location;
  let { data = {} } = await apiInstance.get(
    `/api/bimasathi/list-users?state=${encodeURIComponent(
      state
    )}&city=${encodeURIComponent(city)}&case_id=${encodeURIComponent(case_id)}`
  );
  return data;
};

export const reassignToIM = async (payload) => {
  let { data = {} } = await apiInstance.put("/api/utils/re-assign-im", payload);
  return data;
};

export const getRegulatoryDetails = async (details = {}) => {
  let { caseId = 0, findAll = 0 } = details;
  let { data = {} } = await apiInstance.get(
    `/api/irdai/regulatory-details/${caseId}?findall=${findAll}`
  );
  return data;
};

export const regulatoryDetailsPostApi = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "/api/irdai/regulatory-details",
    payload
  );
  return data;
};

export const withdrawalCase = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "/api/allocation/withdraw-multiple-investigation",
    payload
  );
  return data;
};

export const reassignVendorManual = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "/api/allocation/reassign/manual/vendor-allocate",
    payload
  );
  return data;
};
export const reassignVendorAuto = async (type, payload) => {
  let { data = {} } = await apiInstance.put(
    `api/allocation/reassign/auto/vendor-allocate/${type}-vendor`,
    payload
  );
  return data;
};

export const getInvestigationDetail = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "/api/bimasathi/summary-detail",
    payload
  );
  return data;
};
export const irdaiDetails = async (caseId, payload) => {
  let { data = {} } = await apiInstance.get(
    `api/irdai/vendor-regulatory-details/${caseId}`,
    payload
  );
  return data;
};

export const allTabSearchApi = async (firstTabVal, payload) => {
  let { data = {} } = await apiInstance.post(
    `api/case/case-management/search/${firstTabVal}`,
    payload
  );
  return data;
};

export const getFileHandoverDetails = async (caseId, payload) => {
  let { data = {} } = await apiInstance.get(
    `/api/case/file-handover-detail/${caseId}`,
    payload
  );
  return data;
};

export const postFileHandoverDetails = async (caseId, payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/case/file-handover-detail/${caseId}`,
    payload
  );
  return data;
};

export const investigationTypeApi = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `api/case/manual-investigation/${caseId}`,
    payload
  );
  return data;
};

export const getRlmuComment = async (caseId, payload) => {
  let { data = {} } = await apiInstance.get(
    `api/case/rlmu-comments/${caseId}`,
    payload
  );
  return data;
};

export const postRlmuComment = async (payload) => {
  let { data = {} } = await apiInstance.post(
    `api/case/rlmu-comments/`,
    payload
  );
  return data;
};
